// Convertir formato HH:MM a minutos desde medianoche para facilitar comparaciones
export const timeToMinutes = (timeString) => {
  const [hours, minutes] = timeString
    .split(":")
    .map((num) => parseInt(num, 10));
  return hours * 60 + minutes;
};
